import * as React from 'react';
import { AlertCircle, AlertTriangle, InfoCircle, CheckCircle } from '@untitled-ui/icons-react';
import { BannerNotificationType } from '@deltasierra/shared';

export const getBannerBackgroundColor = (type: BannerNotificationType) => {
    switch (type) {
        case 'success':
            return '#C4F5E5';
        case 'warning':
            return '#FEF8D8';
        case 'error':
            return '#FEE5D7';
        case 'info':
        default:
            return '#EDE7FD';
    }
};

export const getBannerIcon = (type: BannerNotificationType) => {
    switch (type) {
        case 'success':
            return <CheckCircle />;
        case 'warning':
            return <AlertTriangle />;
        case 'error':
            return <AlertCircle />;
        case 'info':
        default:
            return <InfoCircle />;
    }
};

export const getBannerTextColor = (type: BannerNotificationType) => {
    switch (type) {
        case 'success':
            return '#08696b';
        case 'warning':
            return '#AB2738';
        case 'error':
            return '#AB2738';
        case 'info':
        default:
            return '#5E2CF0';
    }
};
